var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.show)?_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 1.3rem)","border":"medium none"},attrs:{"src":_vm.urls}}):_vm._e()]),_c('Tab')],1)}
var staticRenderFns = []

export { render, staticRenderFns }